module.exports = __webpack_public_path__ + "static/media/icons.b3013a90.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/icons.svg
 ** module id = 335
 ** module chunks = 0
 **/